import React, { useContext } from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import { AuthContext } from '../../../context/authContext';
import useSoloLecturaMatriculas from '../../../hooks/useSoloLecturaMatriculas';
import { convocatoriasAgotadas } from '../../../helpers/convocatorias';

const InputModulos = ({
  obj,
  modulos,
  setTotal,
  setTotalSuelto,
  totalSuelto,
  setModulos,
  markModulosDirty,
  setHoursCounter,
  hoursCounter,
  total,
  total2,
  setTotal2,
  setTotalSuelto2,
  totalSuelto2,
  estado,
  dataApi,
}) => {
  const { userOU } = useContext(AuthContext);
  const soloLectura = useSoloLecturaMatriculas();

  // Función para controlar los cambios de los checkbox
  const handleCheckboxChange = (e) => {
    if (markModulosDirty) markModulosDirty();
    if (!modulos.includes(`${obj.modulo} ${obj.descripcion}`)) {
      const newArr = modulos;
      const splitted = e.target.value.split('HH');
      if (
        !splitted[0].includes('Formación en el centro de trabajo') &&
        !splitted[0].includes('Formación en centros de trabajo')
      ) {
        const notaAsInt = parseInt(splitted[1], 10);
        setHoursCounter(hoursCounter + notaAsInt);
      }
      if (obj.curso === 'PRIMERO') {
        setTotal(total + obj.precio);
        setTotalSuelto(totalSuelto + obj.importe_suelto);
      } else {
        setTotal2(total2 + obj.precio);
        setTotalSuelto2(totalSuelto2 + obj.importe_suelto);
      }

      newArr.push(splitted[0].trim());
      setModulos([...newArr]);
    } else {
      const splitted = e.target.value.split('HH');
      const text = splitted[0].trim();
      const index = modulos.indexOf(text);
      if (index !== -1) {
        if (
          !splitted[0].includes('Formación en el centro de trabajo') &&
          !splitted[0].includes('Formación en centros de trabajo')
        ) {
          const notaAsInt = parseInt(splitted[1], 10);
          setHoursCounter(hoursCounter - notaAsInt);
        }
        if (obj.curso === 'PRIMERO') {
          setTotal(total - obj.precio);
          setTotalSuelto(totalSuelto - obj.importe_suelto);
        } else {
          setTotal2(total2 - obj.precio);
          setTotalSuelto2(totalSuelto2 - obj.importe_suelto);
        }

        const newArr = modulos;
        newArr.splice(index, 1);
        setModulos([...newArr]);
      }
    }
  };

  if (dataApi.length === 0) return null;

  return (
    <Input
      type="checkbox"
      id={obj.codigo}
      name="option"
      value={`${obj.modulo} ${obj.descripcion} HH${obj.horas}`}
      onChange={handleCheckboxChange}
      checked={modulos.includes(`${obj.modulo} ${obj.descripcion}`)}
      disabled={
        obj.Nota === 1 ||
        convocatoriasAgotadas(obj) ||
        estado ||
        dataApi[0].estado === 'Revisar secretaria' ||
        userOU.centro === 'ORIENTACIÓN' ||
        soloLectura
      }
    />
  );
};
InputModulos.propTypes = {
  hoursCounter: PropTypes.number,
  setHoursCounter: PropTypes.func,
  total: PropTypes.number,
  setTotal: PropTypes.func,
  totalSuelto: PropTypes.number,
  setTotalSuelto: PropTypes.func,
  setTotal2: PropTypes.func,
  total2: PropTypes.number,
  setTotalSuelto2: PropTypes.func,
  totalSuelto2: PropTypes.number,
  obj: PropTypes.object,
  modulos: PropTypes.array,
  setModulos: PropTypes.func,
  markModulosDirty: PropTypes.func,
  estado: PropTypes.bool,
  dataApi: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default InputModulos;
